import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export const profileSettingsOptionsQueryKey = 'profile-settings-options';

export function useProfileSettingsOptions() {
    return useQuery({
        queryKey: [profileSettingsOptionsQueryKey],
        queryFn: () => sdClient.getProfileOptions({}),
    });
}
